<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div data-app="true" class="data_dict">
      <v-form ref="add_dataDict" v-model="add_dataDict">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12">
                <mrc_ess_multiText
                  :label="$t('label_The_title')"
                  :isNational="judegNational('title')"
                  :readonly="disabled"
                  style="width: 100%"
                  :error-messages="
                    $errors(
                      'logDetail',
                      'title',
                      requiredRule.concat(nocharacter)
                    )
                  "
                  v-model="logDetail.title"
                ></mrc_ess_multiText>
              </v-col>
              <v-col cols="12" sm="12">
                <mrc_ess_multiText
                  :label="$t('label_Body')"
                  :isNational="judegNational('body')"
                  :readonly="disabled"
                  style="width: 100%"
                  v-model="logDetail.body"
                ></mrc_ess_multiText>
              </v-col>
              <v-col cols="12" sm="6">
                <mrc_ess_multiText
                  :label="$t('label_clientType')"
                  :isNational="true"
                  :readonly="disabled"
                  style="width: 100%"
                  v-model="logDetail.client_type"
                ></mrc_ess_multiText>
              </v-col>
              <v-col cols="12" sm="3">
                <mrc_ess_multiText
                  :label="$t('label_username')"
                  :isNational="true"
                  :readonly="disabled"
                  style="width: 100%"
                  v-model="logDetail.preferred_name"
                ></mrc_ess_multiText>
              </v-col>
              <!-- 员工编码 -->
              <v-col cols="12" sm="3">
                <mrc_ess_multiText
                  :label="$t('label_staff_code')"
                  :isNational="false"
                  :readonly="disabled"
                  v-model="logDetail.staff_code"
                ></mrc_ess_multiText>
              </v-col>
              <!-- 状态 -->
              <v-col cols="12" sm="12" class="mrc-border-solid rounded-lg py-8">
                <div>{{ $t("label_state") }}:{{ INT(logDetail.status) }}</div>
                <div>{{ $t("Response") }}:{{ logDetail.response }}</div>
                <div>
                  {{ $t("label_Is_read") }}:{{ INT(logDetail.is_read) }}
                </div>
              </v-col>

              <!-- 图标 -->
              <v-col cols="12" sm="6">
                <mrc_ess_brandupload
                  v-model="logDetail.icon"
                  :label="$t('label_Icon')"
                  :disabled="disabled"
                  @changeimgSrc="changeimgSrc"
                ></mrc_ess_brandupload>
              </v-col>
              <!-- 图标 -->
              <v-col cols="12" sm="6">
                <mrc_ess_brandupload
                  v-model="logDetail.image"
                  :label="$t('label_Photo')"
                  :disabled="disabled"
                  @changeimgSrc="changeimgSrc"
                ></mrc_ess_brandupload>
              </v-col>
              <!-- remarks -->
              <v-col cols="12" sm="12">
                <mrc_ess_multiTextarea
                  :label="$t('label_describe')"
                  :isNational="judegNational('remarks')"
                  :readonly="disabled"
                  v-model="logDetail.remarks"
                >
                </mrc_ess_multiTextarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { getMessageLogsDetailDetail } from "@/service/api/pushMessageLogs";
import confirm from "@/components/confirm";
import { required, between } from "vuelidate/lib/validators";
export default {
  components: { confirm },
  props: {},
  data() {
    return {
      csuuid: "",
      loading: false,
      skLoading: true,
      is_change: 1, // 是否有删除的权限
      isLoading: false,
      is_return: false,
      isOpen: false,
      disabled: false,
      add_dataDict: true,
      is_used: true,
      params: {
        "~table~": "mrbase_sys_message_push_log_detail",
      },
      logDetail: {
        "~table~": "mrbase_sys_message_push_log_detail",
        uuid: "",
        title: "", // 字典名称
        dict_label: "", // 显示标签
        dict_value: "", // 保存值
        is_used: "", // 是否启用
        client_type: [], // 客户端类型
        sequence: 1, // 排序
        dict_value_color: "",
        dict_value_img: "",
      },
    };
  },
  validations: {
    logDetail: {
      client_type: {
        required,
      },
      title: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      dict_value: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      dict_label: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      sequence: {
        required,
        between: between(0, 999),
      },
    },
  },
  created() {},
  async mounted() {
    // 有uuid传过来 就是修改
    await this.national("mrbase_sys_message_push_log_detail");
    this.skLoading = true;
    // const name = this.$store.getters.subPage_name
    const uuid = this.$route.params.uuid || this.$store.state.uuid;
    const is_change =
      this.$route.params.is_change || this.$store.state.is_change;
    if (is_change == 1) {
      this.is_change = is_change;
    }
    if (uuid) {
      if (this.$store.state.iconstatus) {
        this.disabled = true;
      }
      this.logDetail.uuid = uuid;

      // 查询详情
      const detailObj = await getMessageLogsDetailDetail({
        uuid: this.logDetail.uuid,
        "~table~": this.params["~table~"],
      });

      // for(var key in data) {
      //   for(var a in this.logDetail) {
      //     if (key == a) {
      //       this.logDetail[a] = data[key]
      //     }
      //   }
      // }
      this.logDetail = detailObj.data;
      // console.log(this.logDetail.client_type,'client-type')
      // this.logDetail.client_type = this.logDetail.client_type ?this.logDetail.client_type.split(',') : []
      this.logDetail.is_used ? (this.is_used = true) : (this.is_used = false);
      this.temp = this.logDetail;
    } else {
      this.disabled = false;
    }
    this.skLoading = false;
  },
  methods: {
    changeimgSrc(v) {
      this.file = v;
    },
    changeimgSrc2(v) {
      this.file2 = v;
    },
    // 验证排序是否是数字 不是数字就重置为0
    verifyNum(e) {
      if (!/^[1-9]*$/.test(Number(e.target.value))) {
        this.logDetail.sequence = 1;
        e.target.value = 1;
      }
    },
    // 点击修改icon
    handleEdit() {
      this.disabled = !this.disabled;
    },
    // 点击返回上一页
    handleReturn() {
      this.$router.go(-1);
    },
    // 点击删除此参照
    handleDel() {
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          const obj = Object.assign(
            {},
            { uuid: this.logDetail.uuid, "~table~": this.params["~table~"] }
          );
          const res = await getDelete(obj);
          if (res.code == 200) {
            // console.log(this.$parent.desserts.length, this.$parent.params.cpage)
            // if (
            //   this.$parent.desserts.length === 1 &&
            //   this.$parent.params.cpage > 1
            // ) {
            //   this.$parent.params.cpage--
            //   this.$parent.params.totalpage--
            // }

            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
          }
          this.$router.go(-1);
        })
        .catch(() => {});
      // this.isOpen = true
      // this.showText = this.$t('info.is_del')
    },
    // 取消 修改或者添加
    async cancel() {
      if (this.logDetail.uuid) {
        const detailObj = await getMessageLogsDetailDetail({
          uuid: this.logDetail.uuid,
          "~table~": this.params["~table~"],
        });

        this.logDetail = detailObj.data;
        this.logDetail.is_used ? (this.is_used = true) : (this.is_used = false);
        this.temp = this.logDetail;
        this.disabled = true;
      } else {
        const uuid = this.$route.params.uuid || this.$store.state.uuid;
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => {});
      }
    },
    // 提交
    async success() {
      this.$v.logDetail.$touch();
      const isSubmit = this.$refs.add_dataDict.validate();
      if (!isSubmit || this.$v.logDetail.$error) {
        return;
      }
      this.isLoading = true;
      this.logDetail.is_used = this.is_used ? 1 : 0;
      // 深拷贝要传的数据，  因为那个客户端呢类型数组要转成字符串
      let obj = this.$clone(this.logDetail);
      obj.client_type = obj.client_type.join();
      // return
      // 修改
      this.loading = true;

      await this.$uploadFiles(this.file, {
          module_uuid:'module',
          function_uuid: this.$store.state.menuFunctionUuid,

        uuid: this.$store.state.currentCompanyClientUuid,
      }).then(async (res) => {
        let urllist = "";
        if (typeof res == "object" && res != undefined && res.code == 200) {
          obj.dict_value_img = res.uuid;
          urllist = res.uuid;
        }

        if (this.logDetail.uuid) {
          // return
          const res = await getChange({
            "~table~": this.params["~table~"],
            uuid: obj.uuid,
            title: obj.title, // 字典名称
            dict_label: obj.dict_label, // 显示标签
            dict_value: obj.dict_value, // 保存值
            is_used: obj.is_used, // 是否启用
            client_type: obj.client_type, // 客户端类型
            sequence: obj.sequence, // 排序
            dict_value_color: obj.dict_value_color,
            dict_value_img: obj.dict_value_img,
          });
          if (res.code == 200) {
            // this.$store.commit(
            //   'newsTips',
            //   this.$t('message_The_operation_was_successful')
            // )
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.temp = this.logDetail;
            // this.$router.go(-1)
            this.disabled = true;
          } else {
            this.$deleteFile(urllist);
          }
          this.loading = false;
        } else {
          // 添加
          const res = await getAdd({
            "~table~": this.params["~table~"],
            // uuid: obj.uuid,
            title: obj.title, // 字典名称
            dict_label: obj.dict_label, // 显示标签
            dict_value: obj.dict_value, // 保存值
            is_used: obj.is_used, // 是否启用
            client_type: obj.client_type, // 客户端类型
            sequence: obj.sequence, // 排序
            dict_value_color: obj.dict_value_color,
            dict_value_img: obj.dict_value_img,
          });
          if (res.code == 200) {
            // this.$store.commit(
            //   'newsTips',
            //   this.$t('message_The_operation_was_successful')
            // )
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.$router.go(-1);
          } else {
            this.$deleteFile(urllist);
          }
          this.loading = false;
        }
        this.isLoading = false;
      });
    },
  },
  computed: {},
  watch: {
    disabled: {
      handler(v) {
        if (!this.$store.state.uuid) return;
        if (!v) {
          this.$route.meta.title = "label_edit_message_log_detail";
          this.$store.commit("set_page_title", "label_edit_message_log_detail");
        } else {
          this.$route.meta.title = "label_view_message_log_detail";
          this.$store.commit("set_page_title", "label_view_message_log_detail");
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped>
.data_dict /deep/ .v-menu__content {
  min-width: 400px !important;
}
.iconGroup {
  position: relative;
}
.returnBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 130px;
}
.editBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 70px;
}
.delBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 10px;
}
</style>
